import { IFile } from "../api.service";
import { AuthService } from "../auth.service";
import { HelpersService } from "../helpers.service";
import { BaseEventsReceiver } from "./base-events-receiver";
import { IMessageConverter, IMessage, MessageContent } from "./imessage.interface";

import { inject } from "@angular/core";

export interface InNewDisputeEvent {
    event: 'NEW_DISPUTE_MESSAGE',
    data: {
        chatId: number,
        message: {
            id: number,
            user?: {
                id: number;
                fio: string;
                lastOnline: number;
                image?: {
                    blurHash: string;
                    orig: string;
                    originalFilename: string;
                    ext: string;
                    contentType: string
                }
            },
            admin?: any,
            text: string,
            fileIds: {
                id: number;
                name?: string;
                url?: string;
                contentType?: string;
                size?: string | number | null;
                blurhash?: string;
            }[],
            createdAt: number,
            updatedAt: number
        }
    }
}

export interface OutNewDisputeEvent {
    event: 'NEW_DISPUTE_MESSAGE';
    data: OutDataToDispute
}
export interface OutDataToDispute {
    disputeChatId: number;
    text?: string | null;
    files?: number[] | null;
}

export class DisputeReceiver
    extends BaseEventsReceiver<IMessage, OutNewDisputeEvent>
    implements IMessageConverter
{
    authService = inject(AuthService);
    helpersService = inject(HelpersService);

    outcomingEventToIMessage(
        event: {
            disputeChatId: number
            text: string | null,
            files: IFile[] | null,
            event: 'NEW_DISPUTE_MESSAGE'
        },
    ): IMessage {
        const currentDateTime = this.helpersService.getCurrentISO();

        let files: {
            id: number;
            name?: string;
            url?: string;
            contentType?: string;
            size?: string | null;
            blurhash?: string;
        }[] = []

        if(event.files) {
            for(let f of event.files) {
                files.push(
                    {
                        id: f.id,
                        name: f.name,
                        url: f.fileUrl,
                        size: f.size
                    }
                )
            }
        }

        const user = this.authService.user()
        const newIMessage: IMessage = {
            id: -Date.now(),
            chatId: event.disputeChatId,
            content: {
                text: event.text,
                files: files,
                isRead: false,
                sender: {
                    id: user!.id,
                    name: user!.username,
                    role: user!.role
                }
            },
            createdAt: currentDateTime,
            updatedAt: currentDateTime
        }

        return newIMessage;
    }

    incomingEventToIMessage(event: InNewDisputeEvent ): IMessage {
        const currentDateTime = this.helpersService.getCurrentISO();

        let content: MessageContent = {
            text: event.data.message.text,
            files: event.data.message.fileIds.map((x) => {
                return {
                    id: x.id,
                    name: x.name,
                    url: x.url,
                    blurhash: x.blurhash,
                    contentType: x.contentType
                };
            }),
            isRead: false,
            sender: {
                id: event.data.message.user?.id ?? event.data.message.admin?.id,
                name: event.data.message.user?.fio ?? '??',
                role: "<??>"
            }
        };

        return {
            id: event.data.message.id,
            chatId: event.data.chatId,
            content,
            createdAt: currentDateTime,
            updatedAt: currentDateTime,
        };
    }

    clearTempMessages() {
            this.eventsList.set([
            ...this.eventsList().filter((x)=>x.id > 0)
        ]);
    }

    clearTempMessagesNotChatId(chatId: number) {
        this.eventsList.set([
            ...this.eventsList().filter((x)=>x.chatId === chatId)
        ]);
    }

    clearNotTempMessages() {
        this.eventsList.set([
            ...this.eventsList().filter((x)=>x.id < 0)
        ]);
    }
}
